import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthApiService } from '../../_core/_services/auth-api.service';
import { NotificationService } from '../../_core/_services/notification.service';


type ForgotPasswordForm = FormGroup<{
  email: FormControl<string>;
}>;

@Component({
  selector: 'app-forgot-password',
  standalone: false,
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.css'
})
export class ForgotPassword {
  submitted = false;
  loading = false;
  sent = false;
  error = '';

  form!: ForgotPasswordForm;

  constructor(
    private fb: FormBuilder,
    private authApi: AuthApiService,
    private notify: NotificationService
  ) {
    this.form = this.fb.nonNullable.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  submit(): void {
    this.submitted = true;
    this.error = '';
    if (this.form.invalid || this.loading) return;

    this.loading = true;
    this.authApi.forgotPassword(this.form.getRawValue().email).subscribe({
      next: res => {
        this.sent = true;
        this.notify.showSuccess(res.message || 'Password reset instructions have been sent.', 'Password Recovery');
      },
      error: err => {
        this.error = err?.error?.message || 'Unable to process the request.';
        this.notify.showError(this.error, 'Password Recovery');
        this.loading = false;
      },
      complete: () => this.loading = false
    });
  }
}
